import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import {} from 'jquery.slimscroll';
import { taOptions } from 'textangular';
import * as _ from 'underscore';
import { CountryListItem } from '../../../../../app.admin/modules/core';
import { WysiwygControllerBase } from '../../../../../app.common/modules/common/controllers/wysiwygControllerBase';
import { PopupServiceCancel } from '../../../../../app.common/modules/common/models/popupServiceCancel';
import { DefinitionsService } from '../../../../../app.common/modules/common/services/definitions.service';
import { GoogleMapService } from '../../../../../app.common/modules/common/services/google-map.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { WysiwygService } from '../../../../../app.common/modules/common/services/wysiwyg.service';
import { Store } from '../../../core';
import { IRetailerRootScope } from '../../../core/models';
import { IShopBusinessType } from '../../models';
import { ShopService } from '../../shop.service';

interface IStore extends Store {
    type?: IShopBusinessType;
}

export class ShopStoreController extends WysiwygControllerBase {
    public static $inject = [
        '$rootScope',
        '$scope',
        '$q',
        '$sce',
        '$document',
        '$timeout',
        'appWysiwygOptions',
        'shopService',
        'notificationService',
        'popupService',
        'googleMapService',
        'wysiwygService',
        'definitionsService',
        '$translate',
        '$uibModal'
    ];

    public store: IStore = null;
    public storeform: angular.xeditable.IEditableFormController;
    public errorStoreName: string = null;
    public errorStoreDescription: string = null;
    public errorStoreAddressLine1: string = null;
    public errorStoreAddressLine2: string = null;
    public errorStoreTown: string = null;
    public errorStorePostcode: string = null;
    public errorStorePhone: string = null;
    public errorStoreEmail: string = null;
    public errorStoreWebsite: string = null;
    public errorStoreBusinessType: string = null;
    public errorStorDescription: string = null;
    public errorStoreMap: string = null;
    public maps = {
        optionsEdit: null,
        optionsView: null,
        edit: null,
        view: null,
        markerEdit: null,
        markerView: null,
        infoWindow: null,
        defaultLatLng: { lat: 51.500152, lng: -0.126236 },
        loadedEdit: false,
        loadedView: false,
        validDistance: 500,
        message: this.$translate.instant('map_hint'),
        zoom: 16, // 100 m
    };
    public shopID: number = null;
    public enumBusinessType: any;
    public dateOptions = {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: null
    };
    public dateEndOptions = {
        formatYear: 'yyyy',
        startingDay: 0,
        minDate: new Date()
    };
    private storeStandard: IStore = null;
    private googleMaps = null;
    private businessTypes: IShopBusinessType[] = null;
    private defaultExhibitionDate = {
        start: new Date(),
        end: new Date(),
        getStart: (date?: Date) => {
            if (!date) {
                date = new Date();
            }
            date.setHours(9, 0, 0);
            return date;
        },
        getEnd: (date?: Date) => {
            if (!date) {
                date = new Date();
            }
            date.setHours(22, 0, 0);
            return date;
        }
    };
    private Country: CountryListItem;

    constructor(
        private $rootScope: IRetailerRootScope,
        protected $scope: ng.IScope,
        private $q: ng.IQService,
        public $sce: ng.ISCEService,
        private $document: ng.IDocumentService,
        private $timeout: ng.ITimeoutService,
        protected taOptions: taOptions,
        private shopService: ShopService,
        private notificationService: NotificationService,
        private popupService: PopupService,
        private googleMapService: GoogleMapService,
        protected wysiwygService: WysiwygService,
        private definitionsService: DefinitionsService,
        private $translate: angular.translate.ITranslateService,
        private $uibModal: ng.ui.bootstrap.IModalService
    ) {
        super($scope, taOptions, wysiwygService);
        this.enumBusinessType = shopService.getEnumBusinessType();
        this.defaultExhibitionDate.end.setMonth(
            this.defaultExhibitionDate.end.getMonth() + 1
        );
    }

    public $onChanges(changes: any) {
        if (changes.shopId && changes.shopId.isFirstChange()) {
            this.shopID = changes.shopId.currentValue;
            this.init();
        }
    }

    public storeFormShow() {
        this.storeform.$show();
        this.maps.loadedEdit = false;
        this.$timeout(this.reloadGoogleMaps.bind(this));
        this.$scope.$emit('openStore', true);
        this.phoneScroll();
    }

    public discardStore() {
        this.storeform.$cancel();
        this.storeform.$setPristine();
        if (!this.shopID) {
            this.$rootScope.$state.go('app.shops');
        }
        this.maps.loadedView = false;
        this.$scope.$emit('openStore', false);
        this.store = angular.copy(this.storeStandard);
        this.$timeout(this.reloadGoogleMaps.bind(this));
    }

    public saveStore() {
        if (this.storeform.$invalid) {
            return 'error';
        }
        this.computeDistanceBetween().then((action: () => void) => {
            action();
            if (this.store.BusinessType === this.enumBusinessType.Restaurant) {
                this.instanceWysiwygService.deleteRemovedTokens(
                    this.store.Menu
                );
            }
        });
        return 'something';
    }

    public async archiveStore() {
        try {
            await this.popupService.confirm({
                title: this.$translate.instant('archive_place'),
                content: `<p>${this.$translate.instant(
                    'archive_place_confirm'
                )}</p>`
            });
            await this.shopService.archiveStore(this.shopID);
            this.$rootScope.$state.go('app.shops');
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClickInstance(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
    }

    public async validateStoreForm(data: any) {
        this.storeform.$invalid = false;
        // -- validate store name
        if (data.storeName == null || data.storeName.trim().length === 0) {
            this.errorStoreName = this.$translate.instant(
                'place_name_required'
            );
        } else if (data.storeName.trim().length < 1) {
            this.errorStoreName = this.$translate.instant(
                'store_name_too_short'
            );
        } else if (data.storeName.trim().length > 256) {
            this.errorStoreName = this.$translate.instant(
                'store_name_too_long'
            );
        } else {
            this.errorStoreName = null;
        }
        // -- validate business type
        this.errorStoreBusinessType =
            this.store.type == null
                ? this.$translate.instant('business_type_required')
                : null;
        // -- validate store description
        if (data.storeDescription == null) {
            this.errorStorDescription = null;
        } else if (
            data.storeDescription.trim().length < 3 &&
            data.storeDescription.trim().length > 0
        ) {
            this.errorStoreDescription = this.$translate.instant(
                'description_too_short'
            );
        } else if (data.storeDescription.trim().length > 1000) {
            this.errorStoreDescription = this.$translate.instant(
                'description_too_long',
                { maxLength: 1000 }
            );
        } else {
            this.errorStoreDescription = null;
        }
        // -- validate store AddressLine1
        if (
            data.storeAddressLine1 == null ||
            data.storeAddressLine1.trim().length === 0
        ) {
            this.errorStoreAddressLine1 = this.$translate.instant(
                'address_line_required',
                { line: 'line1' }
            );
        } else if (data.storeAddressLine1.trim().length < 3) {
            this.errorStoreAddressLine1 = this.$translate.instant(
                'address_line_too_short',
                { line: 'line1' }
            );
        } else if (data.storeAddressLine1.trim().length > 128) {
            this.errorStoreAddressLine1 = this.$translate.instant(
                'address_line_too_long',
                { line: 'line1' }
            );
        } else {
            this.errorStoreAddressLine1 = null;
        }
        // --  validate store AddressLine2
        if (data.storeAddressLine2 == null) {
            this.errorStoreAddressLine2 = null;
        } else if (
            data.storeAddressLine2.trim().length < 3 &&
            data.storeAddressLine2.trim().length > 0
        ) {
            this.errorStoreAddressLine2 = this.$translate.instant(
                'address_line_too_short',
                { line: 'line2' }
            );
        } else if (data.storeAddressLine2.trim().length > 128) {
            this.errorStoreAddressLine2 = this.$translate.instant(
                'address_line_too_long',
                { line: 'line2' }
            );
        } else {
            this.errorStoreAddressLine2 = null;
        }
        // -- validate store town
        if (data.storeTown == null || data.storeTown.trim().length === 0) {
            this.errorStoreTown = this.$translate.instant('town_is_required');
        } else if (data.storeTown.trim().length < 2) {
            this.errorStoreTown = this.$translate.instant('town_too_short');
        } else if (data.storeTown.trim().length > 128) {
            this.errorStoreTown = this.$translate.instant('town_too_long');
        } else {
            this.errorStoreTown = null;
        }
        // -- validate store Postcode
        if (this.Country.Code !== 784) {
            if (
                data.storePostcode == null ||
                data.storePostcode.trim().length === 0
            ) {
                this.errorStorePostcode = this.$translate.instant(
                    'postcode_is_required'
                );
            } else if (data.storePostcode.trim().length < 3) {
                this.errorStorePostcode = this.$translate.instant(
                    'postcode_too_short'
                );
            } else if (data.storePostcode.trim().length > 128) {
                this.errorStorePostcode = this.$translate.instant(
                    'postcode_too_long'
                );
            } else {
                this.errorStorePostcode = null;
            }
        }
        // --  validate store phone
        if (data.storePhone == null) {
            this.errorStorePhone = null;
        } else if (
            data.storePhone.trim().length < 6 &&
            data.storePhone.trim().length > 0
        ) {
            this.errorStorePhone = this.$translate.instant(
                'phone_number_too_short'
            );
        } else if (data.storePhone.trim().length > 50) {
            this.errorStorePhone = this.$translate.instant(
                'phone_number_too_long'
            );
        } else {
            this.errorStorePhone = null;
        }
        // --  validate store email
        this.errorStoreEmail = null;
        if (data.storeEmail) {
            if (!this.definitionsService.regexEmail.test(data.storeEmail)) {
                this.errorStoreEmail = this.$translate.instant(
                    'email_is_invalid'
                );
            } else if (data.storeEmail.trim().length > 100) {
                this.errorStoreEmail = this.$translate.instant(
                    'email_too_long'
                );
            }
        }
        // -- validate store Website
        if (
            data.storeWebsite == null ||
            data.storeWebsite.trim().length === 0
        ) {
            this.errorStoreWebsite = null;
        } else if (!this.definitionsService.regexUrl.test(data.storeWebsite)) {
            this.errorStoreWebsite = this.$translate.instant('url_is_invalid');
        } else if (data.storeWebsite.trim().length > 256) {
            this.errorStoreWebsite = this.$translate.instant('url_too_long');
        } else {
            this.errorStoreWebsite = null;
        }

        this.storeform.$invalid =
            this.errorStoreName != null ||
            this.errorStoreDescription != null ||
            this.errorStoreAddressLine1 != null ||
            this.errorStoreAddressLine2 != null ||
            this.errorStoreTown != null ||
            this.errorStorePostcode != null ||
            this.errorStorePhone != null ||
            this.errorStoreEmail != null ||
            this.errorStoreWebsite != null ||
            this.errorStoreBusinessType != null;

        // --- validate map
        if (this.maps.markerEdit == null) {
            // $scope.errorStoreMap = 'Please point the location of your place on the map.';
            if (!this.storeform.$invalid) {
                await this.$uibModal.open({
                    component: 'positionIsNotSetDialogComponent',
                    windowClass: 'base-modal',
                    resolve: {
                        contentTranslateKey: () => 'drop_a_pin_to_the'
                    }
                }).result;
            }
            return 'something';
        } else {
            this.errorStoreMap = null;
        }

        if (this.storeform.$invalid) {
            return 'something';
        }
        return null;
    }

    public storeFormCancel() {
        this.storeform.$invalid = false;
        this.errorStoreName = null;
        this.errorStoreDescription = null;
        this.errorStoreAddressLine1 = null;
        this.errorStoreAddressLine2 = null;
        this.errorStoreTown = null;
        this.errorStorePostcode = null;
        this.errorStorePhone = null;
        this.errorStoreEmail = null;
        this.errorStoreWebsite = null;
    }

    public mapDragStart() {
        this.maps.edit.setOptions({ draggingCursor: 'move' });
    }

    public mapDragend() {
        this.maps.edit.setOptions({ draggingCursor: 'default' });
    }

    public setMarker($event: any, $params: any) {
        if (this.maps.edit == null) {
            this.resizeGoogleMaps();
            return;
        }
        if (this.maps.markerEdit != null) {
            this.maps.markerEdit.setMap(null);
        }
        this.storeform.$pristine = false;
        this.maps.markerEdit = new this.googleMaps.Marker({
            map: this.maps.edit,
            position: $params[0].latLng,
            title: this.store.Name,
            draggable: true
        });
        this.maps.edit.setCenter($params[0].latLng);
    }

    public mapLoaded(name: string) {
        if (this.storeform.$visible && !this.maps.loadedEdit) {
            this.maps.loadedEdit = true;
            this.reloadGoogleMaps();
        } else if (!this.storeform.$visible && !this.maps.loadedView) {
            this.maps.loadedView = true;
            this.reloadGoogleMaps();
        }
    }

    public openMarkerInfo(map: any, marker: any) {
        new this.googleMaps.Geocoder().geocode(
            { location: marker.getPosition() },
            (results, status) => {
                if (status === this.googleMaps.GeocoderStatus.OK) {
                    this.maps.infoWindow.setContent(
                        results[0].formatted_address
                    );
                    this.maps.infoWindow.open(map, marker);
                }
            }
        );
    }

    public selectBusinessType($item: any, $model: any) {
        this.phoneScroll();
    }

    public trustAsHtml(html: any) {
        return this.$sce.trustAsHtml(html);
    }

    public getLocationFromAdrress($event: any) {
        const address = this.getAddressOfForm();
        const geocoder = new this.googleMaps.Geocoder();
        geocoder.geocode(
            {
                address
            },
            async (results, status) => {
                if (status === this.googleMaps.GeocoderStatus.OK) {
                    this.setMarker(null, [
                        { latLng: results[0].geometry.location }
                    ]);
                    this.maps.edit.setZoom(this.maps.zoom);
                } else {
                    await this.$uibModal.open({
                        component: 'cantDeterminePositionComponent',
                        windowClass: 'base-modal',
                        appendTo: this.$document.find('.containerGmap '),
                        resolve: {
                            contentTranslateKey: () => 'position_doesnt_coincide_of_location'
                        }
                    }).result;
                }
            }
        );
        $event.preventDefault();
        $event.stopPropagation();
    }

    public changeEndDateMinDate() {
        this.dateEndOptions.minDate = new Date(
            this.store.ExhibitionStartDate.toString()
        );
    }

    public changeStartDateMaxDate() {
        this.dateOptions.maxDate = new Date(
            this.store.ExhibitionEndDate.toString()
        );
    }

    private setDefaultMapLocation() {
        // 578 = Norway, 826 = UK, 840 = USA, 978 = Europe, 784 = UAE, 372 = Ireland
        switch (this.Country.Code) {
            case 578: {
                this.maps.defaultLatLng = { lat: 59.9145019, lng: 10.7566006 };
                break;
            }
            case 826: {
                this.maps.defaultLatLng = { lat: 51.500152, lng: -0.126236 };
                break;
            }
            case 840: {
                this.maps.defaultLatLng = { lat: 40.7127, lng: -74.0059 };
                break;
            }
            case 978: {
                this.maps.defaultLatLng = { lat: 50.8450465, lng: 4.3500418 };
                break;
            }
            case 784: {
                this.maps.defaultLatLng = { lat: 25.0657000, lng: 55.1712800 };
                break;
            }
            case 372: {
                this.maps.defaultLatLng = { lat: 53.342754, lng: -6.271849 };
                break;
            }
        }
    }

    private async init() {
        try {
            this.Country = await this.shopService.getCountry();
            this.setDefaultMapLocation();
            const response = await this.$q.all([
                this.shopService.getBusinessTypes(),
                this.googleMapService.getGoogleMaps()
            ]);
            this.businessTypes = response[0] as IShopBusinessType[];
            this.googleMaps = response[1];
            if (this.shopID == null) {
                this.store = {
                    Name: null,
                    AddressLine1: null,
                    AddressLine2: null,
                    BusinessType: null,
                    ContactEmail: null,
                    ContactPhoneNumber: null,
                    County: this.Country.Name,
                    Description: null,
                    Latitude: null,
                    Longitude: null,
                    Town: null,
                    PostCode: null,
                    BookingTableEnabled: false,
                    LoyaltyProgramID: null,
                    ExhibitionStartDate: this.defaultExhibitionDate.getStart(),
                    ExhibitionEndDate: this.defaultExhibitionDate.getEnd(
                        this.defaultExhibitionDate.end
                    ),
                    type: null
                };
                this.$scope.$emit('setStore', this.store);
                this.storeform.$show();
                this.setGoogleMaps(null, null);
                this.dateOptions.maxDate = this.store.ExhibitionEndDate;
                this.dateEndOptions.minDate = this.store.ExhibitionStartDate;
            } else {
                this.getStore(this.shopID);
            }
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
    }

    private async getStore(id: number) {
        this.notificationService.showWaitingMessage();
        this.storeform.$waiting = true;
        try {
            this.store = await this.shopService.getStore(id);
            this.store.ExhibitionStartDate = this.store.ExhibitionStartDate
                ? this.getLocalDate(this.store.ExhibitionStartDate)
                : this.defaultExhibitionDate.start;
            this.store.ExhibitionEndDate = this.store.ExhibitionEndDate
                ? this.getLocalDate(this.store.ExhibitionEndDate)
                : this.defaultExhibitionDate.end;
            this.store.type = _.findWhere(this.businessTypes, {
                value: this.store.BusinessType
            });
            this.storeStandard = angular.copy(this.store);
            this.$rootScope.app.description = this.store.Name;
            this.$scope.$emit('setStore', this.store);
            this.setGoogleMaps(this.store.Latitude, this.store.Longitude);
            this.notificationService.clearAll();
            this.dateOptions.maxDate = this.store.ExhibitionEndDate;
            this.dateEndOptions.minDate = this.store.ExhibitionStartDate;
        } catch (error) {
            this.store = null;
            this.shopID = null;
            this.notificationService.showErrorMessage(error);
        }
        this.storeform.$waiting = false;
        this.phoneScroll();
    }

    private getLocalDate(sourceDate: any): any {
        const date = new Date(sourceDate.toString());
        date.setHours(date.getHours() + date.getTimezoneOffset() / 60);
        return date;
    }

    private _saveStore() {
        if (this.shopID) {
            this.updateStore();
        } else {
            this.createStore();
        }
    }

    private async createStore() {
        this.notificationService.showWaitingMessage();

        this.storeform.$waiting = true;

        try {
            const id = await this.shopService.createStore(this.getServerModel());

            this.notificationService.showSuccessMessage({
                body: this.$translate.instant('place_created')
            });
            this.$timeout(() => {
                this.$rootScope.$state.go('app.shop', { id });
            }, 1000);
            this.storeStandard = angular.copy(this.store);
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }

        if (this.storeform) {
            this.$timeout(() => {
                this.storeform.$waiting = false;
            }, 1500);
        }
        return 'something';
    }

    private async updateStore() {
        this.storeform.$waiting = true;
        try {
            if (this.storeStandard.LoyaltyProgramID) {
                if (
                    this.storeStandard.Name.trim().toLowerCase() !==
                    this.store.Name.trim().toLowerCase()
                ) {
                    throw new Error('Can\'t change store name, because loyalty program already running for this store.');
                }

                if (
                    this.storeStandard.Town.trim().toLowerCase() !==
                    this.store.Town.trim().toLowerCase()
                ) {
                    throw new Error('Can\'t change town, because loyalty program already running for this store.');
                }
            }
            this.notificationService.showWaitingMessage();

            await this.shopService.updateStore(
                this.shopID,
                this.getServerModel()
            );
            this.notificationService.showSuccessMessage();
            this.storeform.$cancel();
            this.storeform.$setPristine();
            this.$scope.$emit('openStore', false);
            this.$scope.$emit('updateStore', this.store);
            this.maps.optionsEdit.center = this.maps.markerEdit.getPosition();
            this.maps.optionsView.center = this.maps.markerEdit.getPosition();
            this.maps.loadedView = false;
            this.storeStandard = angular.copy(this.store);
            this.storeform.$waiting = false;
            this.$timeout(this.reloadGoogleMaps.bind(this));
            return null;
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClickInstance(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
        this.storeform.$waiting = false;
        return 'something';
    }

    private getServerModel() {
        const position = this.maps.markerEdit.getPosition();
        this.store.Latitude = position.lat();
        this.store.Longitude = position.lng();
        this.store.BusinessType = this.store.type.value as Store.BusinessTypeEnum;
        const model = angular.copy(this.store);
        if (model.BusinessType === this.enumBusinessType.Exhibition) {
            model.ExhibitionStartDate.setHours(
                model.ExhibitionStartDate.getHours() -
                    model.ExhibitionStartDate.getTimezoneOffset() / 60
            );
            model.ExhibitionEndDate.setHours(
                model.ExhibitionEndDate.getHours() -
                    model.ExhibitionEndDate.getTimezoneOffset() / 60
            );
        } else {
            model.ExhibitionEndDate = null;
            model.ExhibitionStartDate = null;
        }
        return model;
    }

    // google maps
    private setGoogleMaps(lat: number, lng: number) {
        let position = null;
        if (lat === null || lng === null) {
            position = new this.googleMaps.LatLng(
                this.maps.defaultLatLng.lat,
                this.maps.defaultLatLng.lng
            );
        } else {
            position = new this.googleMaps.LatLng(lat, lng);
        }

        this.maps.optionsEdit = {
            center: position,
            zoom: this.maps.zoom,
            mapTypeId: this.googleMaps.MapTypeId.ROADMAP,
            zoomControl: true,
            scrollwheel: true,
            disableDefaultUI: true,
            disableDoubleClickZoom: false,
            scaleControl: true,
            draggableCursor: 'default',
            draggingCursor: 'default'
        };

        this.maps.infoWindow = new this.googleMaps.InfoWindow();
        this.maps.optionsView = angular.copy(this.maps.optionsEdit);
        this.maps.optionsView.draggingCursor = 'move';
        this.resizeGoogleMaps();
    }

    private resizeGoogleMaps() {
        this.$timeout(() => {
            if (!this.storeform) {
                return;
            }
            if (this.storeform.$visible && this.maps.edit != null) {
                this.googleMaps.event.trigger(this.maps.edit, 'resize');
            } else if (this.maps.view != null) {
                this.googleMaps.event.trigger(this.maps.view, 'resize');
            }
        }, 300);
    }

    private reloadGoogleMaps() {
        if (this.storeform.$visible) {
            if (this.shopID == null && this.maps.edit != null) {
                this.maps.edit.setCenter(this.maps.optionsEdit.center);
            } else {
                if (this.maps.markerEdit != null) {
                    this.maps.markerEdit.setMap(null);
                }
                this.maps.markerEdit = new this.googleMaps.Marker({
                    map: this.maps.edit,
                    position: this.maps.optionsEdit.center,
                    title: this.store.Name,
                    draggable: true
                });
                this.maps.markerEdit.addListener('drag', (event) => {
                    this.storeform.$pristine = false;
                });
                if (this.maps.edit != null) {
                    this.maps.edit.setCenter(this.maps.optionsEdit.center);
                }
            }
        } else if (!this.storeform.$visible && this.maps.view != null) {
            if (this.shopID === null) {
                this.maps.view.setCenter(this.maps.optionsView.center);
            } else {
                if (this.maps.markerView !== null) {
                    this.maps.markerView.setMap(null);
                }
                this.maps.markerView = new this.googleMaps.Marker({
                    map: this.maps.view,
                    position: this.maps.optionsView.center,
                    title: this.store.Name
                });
                this.maps.view.setCenter(this.maps.optionsView.center);
            }
        }
        this.resizeGoogleMaps();
    }

    private computeDistanceBetween() {
        const deferred = this.$q.defer();
        if (this.isChangedLocation()) {
            const address = this.getAddressOfForm();
            const geocoder = new this.googleMaps.Geocoder();
            geocoder.geocode({ address }, (results, status) => {
                if (status === this.googleMaps.GeocoderStatus.OK) {
                    const computeDistance = this.googleMaps.geometry.spherical.computeDistanceBetween(
                        this.maps.markerEdit.getPosition(),
                        results[0].geometry.location
                    );
                    if (
                        _.isNumber(computeDistance) &&
                        computeDistance <= this.maps.validDistance
                    ) {
                        deferred.resolve(this._saveStore.bind(this));
                    } else if (!_.isNumber(computeDistance)) {
                        deferred.resolve(this.couldNotGetLocationDialog.bind(this));
                    } else if (
                        _.isNumber(computeDistance) &&
                        computeDistance > this.maps.validDistance
                    ) {
                        deferred.resolve(this.placeNotCoincideAddressDialog.bind(this));
                    }
                } else {
                    deferred.resolve(this.couldNotGetLocationDialog.bind(this));
                }
            });
        } else {
            return this.$q.when(this._saveStore.bind(this));
        }
        return deferred.promise;
    }

    private async placeNotCoincideAddressDialog() {
        const res = await this.$uibModal.open({
            component: 'positionDiffersDialogComponent',
            windowClass: 'base-modal',
            resolve: {
                contentTranslateKey: () => 'position_doesnt_coincide_of_location'
            }
        }).result;
        if (!res) {
            this._saveStore();
        }
    }

    private getAddressOfForm() {
        const { storeTown, storeAddressLine1 } = this.storeform;
        let currentAddress;
        if (!storeTown.$$rawModelValue && !storeAddressLine1.$$rawModelValue) {
            currentAddress = '';
        } else {
            currentAddress = [
                storeTown.$$rawModelValue,
                storeAddressLine1.$$rawModelValue
            ].join(', ');
        }

        return currentAddress;
    }

    private isChangedLocation() {
        if (this.store === null || this.maps.markerEdit === null) {
            return true;
        } else {
            const position = this.maps.markerEdit.getPosition();
            return (
                this.storeStandard == null ||
                this.store.AddressLine1 !== this.storeStandard.AddressLine1 ||
                this.store.Town !== this.storeStandard.Town ||
                this.store.County !== this.storeStandard.County ||
                this.store.Latitude !== position.lat() ||
                this.store.Longitude !== position.lng()
            );
        }
    }

    private async couldNotGetLocationDialog() {
        const res = await this.$uibModal.open({
            component: 'positionDiffersDialogComponent',
            windowClass: 'base-modal',
            resolve: {
                contentTranslateKey: () => 'cant_locate_your_address'
            }
        }).result;
        if (!res) {
            this._saveStore();
        }
    }

    // others
    private phoneScroll() {
        $('.phoneScrollSelector').slimScroll({
            height: 'auto',
            size: '6px',
            alwaysVisible: true
        });
    }
}

angular.module('naut').component('shopStore', {
    template: require('./shopStore.html'),
    controller: ShopStoreController,
    controllerAs: '$ctrl',
    bindings: {
        shopId: '<'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/places/components/shopStore/shopStore.component.ts